const React = require("react");
const T = React.PropTypes;

require("./Impersonation.less");

const Error = require("~/types/Error.js").PropType;
const UserType = require("~/types/User.js").PropType;

const MajorError = require("../MajorError/MajorError.jsx");
const MajorLoading = require("../MajorLoading/MajorLoading.jsx");
const AlterEgo = require("../AlterEgo/AlterEgo.jsx");

const alterEgoLoadDispatchers =
    require("~/events/alterEgoLoad/alterEgoLoadDispatchers.js");
const impersonationDispatchers =
    require("~/events/impersonation/impersonationDispatchers.js");

const Impersonation = React.createClass({
    propTypes: {
        User: UserType.isRequired,
        AlterEgos: T.shape({
            Data: T.arrayOf(UserType),
            IsLoading: T.bool.isRequired,
            Error: Error
        }),
        ImpersonationTransitioning: T.bool.isRequired
    },
    getInitialState() {
        return {
            FilterTerm: ""
        };
    },
    componentWillMount() {
        if (this.props.AlterEgos.Data === null) {
            alterEgoLoadDispatchers.LoadAlterEgos();
        }
    },
    render() {
        const top = this.GetTop();
        const contents = this.GetContents();

        return (<article className="cs-Impersonation">
            {top}
            {contents}
        </article>);
    },
    GetTop() {
        if (this.props.AlterEgos.Error || this.props.AlterEgos.IsLoading) {
            return null;
        }

        const current = this.GetCurrentBox();

        return (<header className="cs-impersonation__top">
            <h3>Select a user to impersonate</h3>
            {current}
            <div className="cs-Impersonation__top-box">
                <label>
                    Filter:
                </label>
                <input type="text"
                       className="form-control cs-Impersonation__top-box__filter"
                       onChange={this.FilterChanged}
                       placeholder="Name" />
            </div>
        </header>);
    },
    GetCurrentBox() {
        if (this.props.ImpersonationTransitioning) {
            return null;
        }

        if (this.props.User.AlterEgo) {
            return (<div className="cs-Impersonation__top-box cs-Impersonation__top-box--first">
                <span className="cs-Impersonation__top-box__currently">
                    Currently impersonating
                    <strong className="cs-Impersonation__top-box__currently__name">
                        {this.props.User.DisplayName}
                    </strong>
                </span>
                <button className="btn btn-danger cs-Impersonation__stop"
                        onClick={this.StopImpersonating}>
                    Stop impersonating
                </button>
            </div>);
        }

        return null;
    },
    GetContents() {
        if (this.props.ImpersonationTransitioning) {            
            return (<div className="cs-Impersonation__no-matches">Updating...</div>);
        }

        if (this.props.AlterEgos.Error) {
            return (<MajorError Error={this.props.AlterEgos.Error } />);
        }

        if (this.props.AlterEgos.IsLoading) {
            return (<MajorLoading />);
        }

        if (this.props.AlterEgos.Data) {
            const upperFilter = this.state.FilterTerm.toUpperCase();

            const entries = this.props.AlterEgos.Data
                .filter((user) => {
                    const upperDisplay = user.DisplayName.toUpperCase();

                    return upperDisplay.indexOf(upperFilter) > -1;
                })
                .map((user, i) => {
                    return (<li key={i }>
                        <AlterEgo User={user} OnSelected={this.StartImpersonating } />
                    </li>);
                });

            return (<ul className="cs-Impersonation__user-list">
                    {entries.length > 0 && entries}
                    {entries.length === 0 && (<li className="cs-Impersonation__no-matches">No matches.</li>)}
                </ul>);
        }

        return null;
    },
    FilterChanged(e) {
        this.setState({
            FilterTerm: e.target.value
        });
    },
    StartImpersonating(account) {
        impersonationDispatchers.StartImpersonating(account);
    },
    StopImpersonating() {
        impersonationDispatchers.StopImpersonating();
    }
});

module.exports = Impersonation;


// WEBPACK FOOTER //
// ./src/components/Impersonation/Impersonation.jsx